module.exports = __webpack_public_path__ + "img/expired-docs.ea6336de.svg";